import { Model, Attr, HasOne } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';
import { Extra, VehicleType } from './';

@Model()
export default class ExtraVariation extends ApplicationRecord {
  static jsonapiType = 'extra-variations';

  static listHeaders() {
    return [
      {
        text: 'ID',
        value: 'id',
        width: 100,
        sortable: false,
      },
      {
        text: 'Vehicle Type',
        value: 'vehicleType.name',
      },
      {
        text: 'Price',
        value: 'price',
      },
    ];
  }

  static scopeFactory() {
    return ExtraVariation.includes(['vehicleType']);
  }

  @Attr() price: string;

  @HasOne() extra: Extra;
  @HasOne() vehicleType: VehicleType;

  get formattedPrice() {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
    }).format(Number(this.price));
  }
}
